<app-breadcrumb [master]="'Administracja'" [parentName]="'Licencje'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Dane">
    <app-license-details-view *ngIf="!modify" [license]="license" (modifyClicked)="modify = true"></app-license-details-view>
    <app-license-add *ngIf="modify" [license]="license" (closeModification)="modify = false; loadLicense()"></app-license-add>
  </mat-tab>
    <mat-tab label="Historia zmian">
        <ng-template matTabContent>
            <app-log-list [license]="license"></app-log-list>
        </ng-template>
    </mat-tab>
</mat-tab-group>
